import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { AdminService } from '../../../../admin.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ResponsibleService } from '@shared/services/responsible.service';
import { SnackService } from '@shared/services/snack.service';
import { IResponsibleUser, IUpdateResponsible, ResponsibleType } from '@shared/interfaces';
import { SortAlphabeticallyPipe } from '@shared/pipes';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-responsible-create',
    templateUrl: './admin-responsible-create.component.html',
    styleUrls: ['./admin-responsible-create.component.scss'],
    providers: [SortAlphabeticallyPipe],
    standalone: false
})
export class AdminResponsibleCreateComponent extends AdminActionsDirective implements OnInit {
    ResponsibleType = ResponsibleType;
    formGroup: UntypedFormGroup;

    constructor(
        private fb: UntypedFormBuilder,
        private responsibleService: ResponsibleService,
        private snack: SnackService,
        private changeDetection: ChangeDetectorRef,
        private aSortPipe: SortAlphabeticallyPipe,
        adminService: AdminService,
        dialogService: DialogService,
        moduleService: ModuleService
    ) {
        super(adminService, dialogService, moduleService);
    }

    ngOnInit() {
        this.buildForm();
    }

    get item(): IUpdateResponsible {
        return this.formGroup.value as IUpdateResponsible;
    }

    async createItem(event: any): Promise<void> {
        const submitter: HTMLButtonElement = event.submitter;

        if (submitter) {
            submitter.disabled = true;
        }

        this.formGroup.markAllAsTouched();
        if (this.formGroup.valid) {
            try {
                const result = await this.responsibleService.createItem(this.formGroup.value);
                this.snack.openSnackBarSuccess(
                    `Responsible item ${result.orgDescription} - ${result.orgCode} created successfully.`
                );
                this.goToResponsible(result);
            } catch (e) {
                this.snack.openSnackBarError(e.error.message);
            }
        } else {
            this.snack.openSnackBarError('Please check your input.');
        }

        if (submitter) {
            submitter.disabled = false;
        }
    }

    get excludedUsers(): IResponsibleUser[] {
        return [
            ...(this.item.mainResponsible || []),
            ...(this.item.mainSpecialists || []),
            ...(this.item.otherResponsible || []),
            ...(this.item.otherSpecialists || [])
        ];
    }

    private buildForm() {
        this.formGroup = this.fb.group({
            title: [null, Validators.required],
            code: [null, Validators.required],
            mainResponsible: [[], Validators.required],
            mainSpecialists: [[], Validators.required],
            otherResponsible: [],
            otherSpecialists: [],
            responsibleType: [ResponsibleType.sag, Validators.required],
            assignedCountries: [[]]
        });
    }

    get isSag(): boolean {
        return this.item ? this.item.responsibleType === ResponsibleType.sag : false;
    }

    changeAssignedCountries(event: string[]) {
        this.aSortPipe.transform(event);
    }
}
